"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BorderBox = require("../BorderBox");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Tooltip__Wrapper",
  componentId: "ymkaxc-0"
})(["position:relative;display:inline-block;"]);

var Tip = (0, _styledComponents.default)(_BorderBox.BorderBox).withConfig({
  displayName: "Tooltip__Tip",
  componentId: "ymkaxc-1"
})(["background:white;border:none;bottom:100%;box-shadow:0 1px 4px 0 rgba(0,0,0,0.2);left:", ";right:", ";margin-bottom:5px;opacity:0;position:absolute;text-align:left;transform:", ";transition:opacity 250ms ease-out;width:", "px;pointer-events:none;&:hover{cursor:default;}&.active{opacity:1;&:hover{opacity:0;}}"], function (p) {
  return p.tipPosition.left === null ? "auto" : "".concat(p.tipPosition.left, "px");
}, function (p) {
  return p.tipPosition.right === null ? "auto" : "".concat(p.tipPosition.right, "px");
}, function (p) {
  return p.tipPosition.center ? "translate(-50%)" : "none";
}, function (p) {
  return p.width;
});

/**
 * A tooltip
 */
var Tooltip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false,
      tipPosition: {
        left: 0,
        center: false,
        right: null
      }
    });

    _defineProperty(_assertThisInitialized(_this), "innerWrapper", /*#__PURE__*/_react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "computeTipPosition", function () {
      var left = 0;
      var right = null;
      var center = false;
      var current = _this.innerWrapper.current;

      if (current) {
        var clientRect = current.getBoundingClientRect();
        var innerWrapperLeft = clientRect.left;
        var innerWrapperRight = clientRect.right;
        var innerWrapperWidth = clientRect.width;
        left = innerWrapperWidth / 2;
        center = true;
        var spillOver = _this.props.width / 2 - left;

        if (spillOver > innerWrapperLeft) {
          center = false;
          left = 0;
          right = null;
        }

        if (spillOver > window.innerWidth - innerWrapperRight) {
          center = false;
          left = null;
          right = 0;
        }
      }

      return {
        center: center,
        left: left,
        right: right
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        active: !_this.state.active
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      _this.setState({
        active: false
      });
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var tipPosition = this.computeTipPosition();
      this.setState({
        tipPosition: tipPosition
      });
    }
  }, {
    key: "render",
    value: function render() {
      var content = typeof this.props.content === "string" ? formattedTip(this.props.content) : this.props.content;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        onClick: this.handleClick,
        onMouseOut: this.handleMouseOut,
        onMouseOver: this.handleMouseOver
      }, /*#__PURE__*/_react.default.createElement(Tip, {
        className: this.state.active && "active",
        p: this.props.size === "sm" ? 0.5 : 2,
        tipPosition: this.state.tipPosition,
        width: this.props.width
      }, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
        size: "2",
        color: "black60"
      }, content)), /*#__PURE__*/_react.default.createElement("div", {
        ref: this.innerWrapper
      }, this.props.children));
    }
  }]);

  return Tooltip;
}(_react.default.Component);

exports.Tooltip = Tooltip;

_defineProperty(Tooltip, "defaultProps", {
  size: "lg",
  width: 230
});

Tooltip.displayName = "Tooltip";

var formattedTip = function formattedTip(tip) {
  var substring = tip.substring(0, 300);

  if (substring !== tip) {
    substring += "…";
  }

  return substring;
};
//# sourceMappingURL=Tooltip.js.map